import { AbstractControl, ValidatorFn } from '@angular/forms';
import { LocalDate } from '../../model/local-date';

export class FormControlValidators {
  private static readonly urlPattern = /^https?:\/\/[^\s/]+\.[^\s]+$/i;

  /**
   * Basic "is likely an URL" validation. Empty values are valid; combine with Validators.required when needed.
   * Requires http:// or https:// and a host that looks like a domain.
   */
  static url(): ValidatorFn {
    return (control: AbstractControl): { pattern: { requiredPattern: string; actualValue: string } } | null => {
      const value = control?.value;
      if (value == null || value === '') return null;

      const text = `${value}`;
      if (this.urlPattern.test(text)) return null;

      return {
        pattern: {
          requiredPattern: this.urlPattern.toString(),
          actualValue: text,
        },
      };
    };
  }

  /**
   * Set a minimum valid date.
   * @param minDate date must be no sooner than this.
   */
  static minLocalDate(minDate: Date | LocalDate): ValidatorFn {
    minDate = LocalDate.fromDate(minDate);
    return (control: AbstractControl): { min: { min: string } } | null => {
      let controlDate = LocalDate.fromDate(control?.value);
      if (controlDate.hasValue && controlDate < minDate) {
        return {
          min: { min: minDate.toISOString() },
        };
      }
      return null;
    };
  }
}
